import { ref } from 'vue'

export const livePerformanceNowMs = ref(
  typeof performance === 'undefined' ? 0 : performance.now(),
)

let timer: number | null = null

function tick(): void {
  if (typeof performance !== 'undefined')
    livePerformanceNowMs.value = performance.now()
}

function stop(): void {
  if (timer !== null && typeof window !== 'undefined')
    window.clearInterval(timer)
  timer = null
}

function start(): void {
  if (typeof window === 'undefined' || timer !== null) return
  tick()
  timer = window.setInterval(tick, 500)
}

function visibility(): void {
  if (typeof document === 'undefined') return
  if (document.hidden) stop()
  else start()
}

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  document.addEventListener('visibilitychange', visibility)
  window.addEventListener('focus', tick)
  visibility()
}
